import 'nav-elements';
import 'form-confirm';
import 'media-credits';
import 'save-animation';
import 'sentry';
import modal from 'modal';


window.modal = modal;
